import { MdMenu } from 'react-icons/md'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { appActions } from '../../store/features/app'
import Logo from '../atoms/Logo'
import Button, { AccentButton } from './Button'


export default function Navbar() {

    const dispatch = useDispatch()

    const toggleMobileMenuVisibility = ()=>{
        dispatch(appActions.toggleHomeMobileMenuShown())
    }

    return (
        <div
            className="py-4 px-11 bg-secondary2 flex justify-between items-center sm:px-6"
        >

            <div>
                <Link to="">
                    <Logo />
                </Link>
            </div>

            <div>

                <ul className="flex list-none md:hidden">
                    <li className="mr-4 no-underline">
                        <Link className='text-inherit hover:scale-50 duration-300' to="/#features">
                            Features
                        </Link>
                    </li>
                    <li className="mr-4 no-underline">
                        <Link className='text-inherit' to="/#pricing">
                            Pricing
                        </Link>
                    </li>
                    <li className="mr-4 no-underline">
                        <Link className='text-inherit' to="/#contact-us">
                            Contact Us
                        </Link>
                    </li>
                    <li className="mr-4 no-underline">
                        <Link to="/#about">
                            About
                        </Link>
                    </li>
                </ul>

            </div>

            <div className="flex md:hidden">
                <Link to="signin">
                    <Button onClick={()=>{}}>
                        Open Shop
                    </Button>
                </Link>
                <Link to="register">
                    <AccentButton onClick={()=>{}}>
                        Register Shop
                    </AccentButton>
                </Link>
            </div>

            <MdMenu onClick={toggleMobileMenuVisibility} className='hidden md:block text-2xl' />
            
        </div>
    )
}
